var CheckoutStepErrorType;
(function(CheckoutStepErrorType) {
    CheckoutStepErrorType["Failed"] = 'failed';
    CheckoutStepErrorType["Refused"] = 'refused';
    CheckoutStepErrorType["Cancelled"] = 'cancelled';
    CheckoutStepErrorType["Error"] = 'error';
    CheckoutStepErrorType["InternalError"] = 'internal-error';
    CheckoutStepErrorType["ShippingStepFailed"] = 'shipping-step-failed';
    CheckoutStepErrorType["ProductPriceUpdated"] = 'product-price-updated';
})(CheckoutStepErrorType || (CheckoutStepErrorType = {}));

export { CheckoutStepErrorType };
//# sourceMappingURL=checkout-step-error-type.js.map
